import { render, staticRenderFns } from "./BmCatalogos.vue?vue&type=template&id=b678488a&"
import script from "./BmCatalogos.vue?vue&type=script&lang=js&"
export * from "./BmCatalogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports